import { instanceNavigateMap } from "./axiosConfigMap";
const accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

export const navigation = async (coord) => {
  try {
    const response = await instanceNavigateMap.get(
      `${coord}?access_token=${accessToken}&geometries=geojson&overview=full`
    );
    return response?.data?.routes[0] ?? {};
  } catch (error) {
    // console.log("Error en navigation API", error);

    throw error;
  }
};
export const getDirections = async (coord, length) => {
  try {
    // console.log("length", length);
    // console.log("coord String directions", coord);

    const response = await instanceNavigateMap.get(
      `${coord}?alternatives=true&continue_straight=true&geometries=geojson&language=es-MX&overview=full&steps=true&waypoints=0;${length}&access_token=${accessToken}`
    );
    // console.log("Response API Directions", response.data);

    // console.log("Response", response.data.routes[0].legs[0].steps);
    return response;
  } catch (error) {
    // console.log("Error en get Directions", error);
    throw error;
  }
};
